import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import _ from 'lodash';
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';
// import '../resource/css/centerlogin.css';
import ReactApexChart from 'react-apexcharts';
import qs from 'query-string';
import config from '../../config';

// TODO
// add some custom css to fix scroll bar




class HospitalChartV2 extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
            chartType:this.props.chartType,
            loading:true,
            error:false,
            series: [],
            options: {
                chart: {
                    height: '100%',
                    type: 'bar',
                    stacked: false
                },
                dataLabels: {
                    enabled: false
                },
                colors: ['#bee8ff', '#00a9e6', '#ffbebe', '#e60000', '#e8beff', '#a900e6' ],
                markers: {
                    size: 2.5,
                },
                stroke: {
                    show: true,
                    curve: 'smooth',
                    lineCap: 'square',
                    // colors: ['#5c5c5c'],
                    width: 2,
                    dashArray: 0,      
                },
                // title: {
                //     text: 'Patient Hospitalizations by Day',
                //     align: 'left',
                //     offsetX: 0,
                //     style:{
                //         fontWeight:'normal'
                //     }
                // },
                // subtitle: {
                //     text: 'COVID-19 Patient Hospitalizations by Day',
                //     align: 'left',
                //     offsetX: 0
                // },
                xaxis: {
                    type: 'datetime',
                    categories: [],
                    labels: {
                        datetimeFormatter: {
                            year: 'yyyy',
                            month: 'MMM dd',
                            day: 'MMM dd',
                        }
                    },
                    axisTicks: {
                        show: true,
                    },
                },
                yaxis: [
                    {
                        seriesName: 'Beds',
                        axisTicks: {
                            show: true,
                        },
                        axisBorder: {
                            show: true,
                            color: '#eaeaea'
                        },
                        title: {
                            text: "Bed Census",
                        },
                        tooltip: {
                            enabled: true
                        }
                    }
                ],
                tooltip: {
                    enabled: true,
                    enabledOnSeries: true,
                    shared: true,
                    followCursor: true,
                    intersect: false,
                    inverseOrder: true,
                    fillSeriesColor: false,
                    style: {
                      fontSize: '10px',
                    },
                    onDatasetHover: {
                        highlightDataSeries: false,
                    },
                    marker: {
                        show: true,
                    },
                },
                legend: {
                    horizontalAlign: 'left',
                    offsetX: 0
                }
            },
      };
    }

    async loadOut(){
        const qValues = qs.parse(this.props.location.search);
        let formData;
        let qResp;
        let qData;
        let cleanDate=[];
        let cleanDayMovingAcuteCare=[];
        let cleanAcute_care_census=[];
        let cleanIcuCensus=[];
        let cleanTotalBedCenus=[];
        let cleanDayMovingIcuCensus=[];
        let cleanDayMovingTotal=[];
        let qWhere="acute_care_census IS NOT NULL";
        let fieldMap;
        let url;
        let qMap={
            Day3:{
                acute:{
                    field:"AcuteCareCensus3DayMovingAvg",
                    text:"3 Day Avg Acute Care Census"
                },
                icu:{
                    field:"ICUCensus3DayMovingAvg",
                    text:"3 Day Avg ICU Census"
                },
                total:{
                    field:"TotalBed3DayMovingAvg",
                    text:"3 Day Avg Total Census"
                }
            },
            Day7:{
                acute:{
                    field:"AcuteCareCensus7DayMovingAvg",
                    text:"7 Day Avg Acute Care Census"
                },
                icu:{
                    field:"ICUCensus7DayMovingAvg",
                    text:"7 Day Avg ICU Census"
                },
                total:{
                    field:"TotalBed7DayMovingAvg",
                    text:"7 Day Avg Total Census"
                }
            },
            Day14:{
                acute:{
                    field:"AcuteCareCensus14DayMovingAvg",
                    text:"14 Day Avg Acute Care Census"
                },
                icu:{
                    field:"ICUCensus14DayMovingAvg",
                    text:"14 Day Avg ICU Census"
                },
                total:{
                    field:"TotalBed14DayMovingAvg",
                    text:"14 Day Avg Total Census"
                }
            }
        };

        // if (qValues.type == null){
        //     qWhere="acute_care_census IS NOT NULL";
        // }else if(qValues.type==="2"){
        //     qWhere="acute_care_census IS NOT NULL AND current14DRecord=1";
        // }else if(qValues.type==="1"){
        //     qWhere="acute_care_census IS NOT NULL";
        // }else{
        //     qWhere="acute_care_census IS NOT NULL";
        // }

        // if (qValues.range == null){
        //     fieldMap=qMap.Day3;
        // } else if(qValues.range==="3"){
        //     fieldMap=qMap.Day3;
        // } else if(qValues.range==="7"){
        //     fieldMap=qMap.Day7;
        // }else if(qValues.range==="14"){
        //     fieldMap=qMap.Day14;
        // }else{
        //     fieldMap=qMap.Day3;
        // }

        if (qValues.type == null){
            url=config.apiv2.covidCases;
            qWhere="acute_care_census IS NOT NULL";
        }else if(qValues.type==="all"){
            url=config.apiv2.covidCases;
            qWhere="acute_care_census IS NOT NULL";
        }else if(qValues.type==="all14"){
            url=config.apiv2.covidRecoveryAllTwoWeeks;
            qWhere="acute_care_census IS NOT NULL";
        }else if(qValues.type==="14"){
            url=config.apiv2.covidRecoveryAllTwoWeeks;
            qWhere="acute_care_census IS NOT NULL AND current14DRecord=1";
        }else{
            url=config.apiv2.covidCases;
            qWhere="acute_care_census IS NOT NULL";
        }
            
        if (qValues.trend == null){
            fieldMap=qMap.Day3;
        } else if(qValues.range==="3"){
            fieldMap=qMap.Day3; 
        } else if(qValues.trend==="7"){
            fieldMap=qMap.Day7;
        }else if(qValues.trend==="14"){
            fieldMap=qMap.Day14;
        }else{
            fieldMap=qMap.Day3;
        }

        formData=new FormData()
        formData.append("where",qWhere);
        formData.append("outFields","*");
        formData.append("returnGeometry","false");
        formData.append("orderByFields","date");
        formData.append("returnDistinctValues","false");
        formData.append("f","json");

        try{
            qResp = await fetch(url+"/query",{method:"post",body:formData});
            qData = await qResp.json();
        }catch(err){
            console.log(err);
        }

        if(_.get(qData,"features.length",0)>0){
            _.forEach(qData.features,function(value,key){
                let validDate = (new Date(value.attributes.date)).getTime();

                let acuteCareCensus = (value.attributes.acute_care_census).toFixed(0);
                let icuCensus = (value.attributes.icu_census).toFixed(0);
                let totalBedCensus = (value.attributes.totalBed).toFixed(0);

                let dayMovingAcuteCare = (value.attributes[fieldMap.acute.field]).toFixed(0);
                let dayMovingIcuCensus = (value.attributes[fieldMap.icu.field]).toFixed(0);
                let dayMovingTotal = (value.attributes[fieldMap.total.field]).toFixed(0);

                cleanDate.push(validDate);
                cleanTotalBedCenus.push(totalBedCensus);
                cleanIcuCensus.push(icuCensus);
                cleanDayMovingAcuteCare.push(dayMovingAcuteCare);
                cleanAcute_care_census.push(acuteCareCensus);
                cleanDayMovingIcuCensus.push(dayMovingIcuCensus);
                cleanDayMovingTotal.push(dayMovingTotal);

            });
            // console.log(cleanTotalTests)

            
            this.setState({
                loading:false,
                error:false,
                series: [{
                    name: 'Acute Care Census',
                    type: 'line',
                    data: cleanAcute_care_census
                },  {
                    name: fieldMap.acute.text,
                    type: 'line',
                    data: cleanDayMovingAcuteCare
                },  {
                    name: 'ICU Census',
                    type: 'line',
                    data: cleanIcuCensus
                },  {
                    name: fieldMap.icu.text,
                    type: 'line',
                    data: cleanDayMovingIcuCensus
                },  {
                    name: 'Total Bed Census',
                    type: 'line',
                    data: cleanTotalBedCenus
                },  {
                    name: fieldMap.total.text,
                    type: 'line',
                    data: cleanDayMovingTotal
                }  ],
                options: {
                  ...this.state.options,
                  xaxis: {
                    ...this.state.options.xaxis,
                    categories:cleanDate
                  }
                }
            });

        }else{
            // error handle
            this.setState({
                loading:false,
                error:true
            });
        }
    }

    componentDidMount(){
        this.loadOut();
    }

    render() {
        

        if(this.state.loading===true){
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <div id="loader" style={{textAlign:"center"}}>
                        <Row>
                            <Col>
                                <Spinner animation="border" variant="primary" />
                            </Col>
                        </Row>
                    </div>
                </Container>
            );

        }else if(this.state.loading===false && this.state.error===true){
            //show error
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <Alert></Alert>
                </Container>
            );
        }else{
            return (
                <div id="chart" style={{height:"92vh",width:"92vw",paddingRight:"0",paddingLeft:"0",paddingTop:"0px"}}>
                    <ReactApexChart options={this.state.options} series={this.state.series} type="line" height={'100%'} />
                </div>
            );
        }
    }
}

export default HospitalChartV2;